import "moment/locale/cs";
import "moment/locale/ru";

import fallbackTexts from "assets/fallbackTexts.json";

import * as ReactDatePicker from "react-datepicker";
import { getLanguage, getTextsData } from "selectors/texts";
import { toast } from "react-toastify";
import Constants from "const/Constants";
import Errors from "const/Errors";
import Languages from "const/Languages";
import LocalStorageKeys from "const/LocalStorageKeys";
import Storage from "utils/Storage";
import Texts from "utils/Texts";
import moment from "moment";

export default class TextsActions {
  static SET_APP_LANGUAGE = "texts/SET_APP_LANGUAGE";

  static FETCH_TEXTS_START = "texts/FETCH_TEXTS_START";

  static FETCH_TEXTS_DONE = "texts/FETCH_TEXTS_DONE";

  static FETCH_TEXTS_ERROR = "texts/FETCH_TEXTS_ERROR";

  static setAppLanguage(language, replacements = null) {
    const firstLoad = !language;

    return async(dispatch, getState) => {
      if (firstLoad) {
        language = Storage.storageValue(LocalStorageKeys.PREFERRED_LANG) || (window.navigator.language || "").split("-")[0];
        if (!Object.values(Languages).some(({ code }) => code === language)) language = Constants.DEFAULT_LANGUAGE;
      }

      const { texts } = getState();

      const action = { type: TextsActions.SET_APP_LANGUAGE, payload: { language } };

      if (texts[language]) dispatch(action);
      else {
        const result = await dispatch(TextsActions.fetchTexts(language, replacements, firstLoad));

        Storage.storageValue(LocalStorageKeys.PREFERRED_LANG, result ? result.language : null);
        if (result) {
          dispatch(action);
        } else if (firstLoad) throw Errors.CRITICAL_DATA_NOT_LOADED;
      }

      const { dateFnsLocale } = Object.values(Languages).find(({ code }) => code === language) || {};

      if (dateFnsLocale) ReactDatePicker.registerLocale(language, dateFnsLocale);
      ReactDatePicker.setDefaultLocale(language);
      moment.locale(language);

      return language;
    };
  }

  static fetchTexts(language, replacements) {
    // TODO: Extract text to external service like POEditor and fetch data by their API
    return async(dispatch, getState) => {
      dispatch({ type: TextsActions.FETCH_TEXTS_START, payload: { language } });
      try {
        let { default: textsData } = await import("assets/texts/" + language + ".json"); //eslint-disable-line

        if (replacements) textsData = JSON.parse(Texts.replaceVars(JSON.stringify(textsData), replacements));
        dispatch({ type: TextsActions.FETCH_TEXTS_DONE, payload: { language, textsData } });

        return { language, textsData };
      } catch (error) {
        const currentLanguage = getLanguage(getState());

        const textsData = getTextsData(getState());

        dispatch({ type: TextsActions.FETCH_TEXTS_ERROR });
        toast.error((textsData[currentLanguage] || fallbackTexts).errors.loadingTexts);

        return null;
      }
    };
  }
}
